import {
	type FetchNftExternalAddressesParamsNetworkTypes,
	type NetworkType,
	type NFTExternalAddress,
	type RecipientItem,
	type RecipientTypes
} from '@capsicum/common';
import { useCallback } from 'react';

import { useExternalAddressesQuery } from '../data-access/queries';

/**
 * @param network - 'ethereum' | 'cc1' | 'polygon'
 * @returns list of recipients per network
 */
export const useMyCollectibleRecipients = (networkTypes: Array<FetchNftExternalAddressesParamsNetworkTypes>) =>
	useExternalAddressesQuery(
		networkTypes,
		useCallback((data: Array<NFTExternalAddress> | undefined): Array<RecipientItem> | undefined => {
			return (
				data &&
				data?.map(recipient => {
					return {
						blockchainAddress: recipient.blockchainAddress,
						exchange: recipient.externalOwnerInfo?.walletOrExchangeName || '',
						id: recipient.id || '',
						label: recipient.label,
						networkType: recipient.tokenOwner.networkType as NetworkType,
						type: recipient.type as RecipientTypes
					};
				})
			);
		}, [])
	);
